module.exports = __webpack_public_path__ + "static/the-daily-stoic-90bdb9b3a7d470d4a32094d363a43d6f.jpg";